module.exports = __webpack_public_path__ + "img/winter.be5030ca.webp";